import { TRACKERS } from "@/constants/Trackers";
import { MetriportHIE } from "@/features/Patient/MedicalRecords/MetriportHIE/MetriportHIE";
import { trackEvent } from "@/lib/tracking";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/patient/$patientId/hie-data")({
  component: RouteComponent,
  onEnter: async () => {
    trackEvent(TRACKERS.NAVIGATE_TO_HIE_DATA);
  },
});

function RouteComponent() {
  return <MetriportHIE />;
}
